import ErrorPage from 'common/ErrorPageDetail';
import { Icon500 } from 'common/icons';

export default function Page500() {
  return <ErrorPage pagTitle='errors.500.page.title'
    errorMsg='errors.500.page.text'
    errorMsgSub='errors.try.again'
    icon={<Icon500 />} />;
}
